export default "__VITE_ASSET__BZQPIBZy__"